import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { AreaChart, Area, XAxis, Tooltip, ResponsiveContainer } from "recharts";
import { api } from "@/lib/api";
import { PageHeader, StatCard } from "@/components/admin/AdminUI";

export default function AdminOverview() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/admin/overview").then((r) => setData(r.data)).catch(() => setData(false));
  }, []);

  if (data === null)
    return (
      <div className="flex h-64 items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  if (data === false) return <p className="text-sm text-destructive">Failed to load overview.</p>;

  const chartData = data.signups_series.map((s) => ({ date: s.date.slice(5), count: s.count }));

  return (
    <div data-testid="admin-overview">
      <PageHeader title="Overview" subtitle="Platform health at a glance" />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
        <StatCard testid="stat-total-users" label="Total users" value={data.total_users} />
        <StatCard testid="stat-paying-users" label="Paying users" value={data.paying_users} accent hint="Active subscriptions" />
        <StatCard testid="stat-suspended" label="Suspended" value={data.suspended_users} />
        <StatCard testid="stat-signups" label="Signups (30d)" value={data.signups_30d} />
        <StatCard testid="stat-job-runs" label="Job runs" value={data.job_runs} hint="All-time extractions" />
      </div>

      <div className="mt-8 rounded-2xl border border-border bg-card p-6" data-testid="signups-chart">
        <p className="mb-1 font-display text-lg font-bold">Signups — last 14 days</p>
        <p className="mb-6 text-sm text-muted-foreground">New user registrations per day</p>
        <div className="h-64 w-full" style={{ minHeight: 256 }}>
          <ResponsiveContainer width="100%" height={256} minHeight={256}>
            <AreaChart data={chartData}>
              <defs>
                <linearGradient id="sg" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity={0.4} />
                  <stop offset="100%" stopColor="hsl(var(--primary))" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="date" tick={{ fontSize: 11 }} stroke="hsl(var(--muted-foreground))" tickLine={false} axisLine={false} />
              <Tooltip
                contentStyle={{
                  background: "hsl(var(--popover))",
                  border: "1px solid hsl(var(--border))",
                  borderRadius: 12,
                  fontSize: 12,
                }}
              />
              <Area type="monotone" dataKey="count" stroke="hsl(var(--primary))" strokeWidth={2} fill="url(#sg)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
